export default {
  // Lucky Draw Config
  "luckydrawConfig.add": "添加",
  "luckydrawConfig.details": "详情",
  "luckydrawConfig.edit": "编辑",
  "luckydrawConfig.delete": "删除",
  "luckydrawConfig.delete.confirm.title": "删除配置",
  "luckydrawConfig.delete.confirm.content": "确定要删除这个配置吗？",
  "luckydrawConfig.delete.confirm.okText": "确定",
  "luckydrawConfig.delete.confirm.cancelText": "取消",
  "luckydrawConfig.modal.title": "幸运抽奖配置",
  "luckydrawConfig.operation.success": "操作成功",
  
  // Table Headers
  "luckydrawConfig.thead.id": "ID",
  "luckydrawConfig.thead.documentId": "文档ID",
  "luckydrawConfig.thead.timeOfArrival": "到账时间",
  "luckydrawConfig.thead.hoursUntilExpiration": "过期小时数",
  "luckydrawConfig.thead.drawBoxAmounts": "抽奖盒数量",
  "luckydrawConfig.thead.getDrawsAmounts": "获得抽奖数量",
  "luckydrawConfig.thead.bindSite": "绑定站点",
  "luckydrawConfig.thead.configName": "配置名称",
  "luckydrawConfig.thead.itemName": "活动名称",
  "luckydrawConfig.thead.itemId": "活动ID",
  "luckydrawConfig.thead.drawType": "抽奖类型",
  "luckydrawConfig.thead.sort": "排序",
  "luckydrawConfig.thead.status": "状态",
  "luckydrawConfig.thead.active": "启用状态",
  "luckydrawConfig.thead.remark": "备注",
  "luckydrawConfig.thead.content": "内容",
  "luckydrawConfig.thead.description": "描述",
  "luckydrawConfig.thead.title": "标题",
  "luckydrawConfig.thead.createdAt": "创建时间",
  "luckydrawConfig.thead.updatedAt": "更新时间",
  "luckydrawConfig.thead.publishedAt": "发布时间",
  "luckydrawConfig.thead.locale": "语言环境",
  "luckydrawConfig.thead.createdBy": "创建者",
  "luckydrawConfig.thead.updatedBy": "更新者",
  "luckydrawConfig.thead.localizations": "本地化",
  "luckydrawConfig.thead.action": "操作",
  
  // Form
  "luckydrawConfig.form.configName.required": "请输入配置名称",
  
  // Status
  "luckydrawConfig.status.active": "启用",
  "luckydrawConfig.status.inactive": "禁用",
};
